module.exports = __webpack_public_path__ + "img/3.58702818.jpg";